<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="300"
    >
      <v-card>
        <v-card-title class="text-h5">
          <strong>{{$i18n.t(header)}}</strong>
        </v-card-title>
        <v-card-text>{{$i18n.t(msg)}}</v-card-text>
        <v-card-actions>
          <v-btn
            color="red darken-1"
            text
            @click="actionTaken(false)"
          >
            No
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="actionTaken(true)"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "SaveButton",
  props: {
    header: {
      default: "Save Trip",
    },
    msg: {
      default: "Sure want to save ?",
    },
    tripSaveDialog: {
      default: null,
    },
  },
})
export default class SaveButton extends (Vue, Themeable) {
    dialog = null;
    actionTaken(action) {
        this.dialog = null;
        this.$emit("preSave", action);
    }

    @Watch("tripSaveDialog")
    onDialog(val) {
      this.dialog = val;
    }
}
</script>